import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { BookmarkedAd } from '../../api';
import { BookmarkCard } from '../BookmarkCard';
import * as S from './BookmarksGrid.styled';
import { useToastStore } from '@/store/useToastStore';
import { useBreakpoint } from '@/hooks/useBreakpoint';
import { BookmarksEmpty } from '@/components/BookmarksEmpty/BookmarksEmpty';

interface BookmarksGridProps {
  loading: boolean;
  hasBookmarks: boolean;
  bookmarks: BookmarkedAd[];
  hasBookmarkButton?: boolean;
}

export const BookmarksGrid = ({
  loading,
  bookmarks,
  hasBookmarks,
  hasBookmarkButton = true,
}: BookmarksGridProps) => {
  const { t } = useTranslation();
  const { isDesktop } = useBreakpoint();
  const { openToast } = useToastStore();

  const handleRemove = useCallback((ad: BookmarkedAd) => {
    openToast({
      image: ad?.photo?.url,
      text: t('bookmark_collections.unbookmarked'),
    });
  }, []);

  if (!loading && !hasBookmarks) {
    return <BookmarksEmpty />;
  }

  const renderLoader = () => {
    const loaderItems = isDesktop ? 8 : 6;

    return Array.from({ length: loaderItems }).map((_, index) => (
      <BookmarkCard key={index} />
    ));
  };

  return (
    <S.BookmarksGrid data-testid="bookmarks-grid">
      {loading
        ? renderLoader()
        : bookmarks.map(bookmark => (
            <BookmarkCard
              ad={bookmark}
              key={bookmark.id}
              onRemove={handleRemove}
              hasBookmarkButton={hasBookmarkButton}
            />
          ))}
    </S.BookmarksGrid>
  );
};
